import axios from "axios";
import CryptoJS from 'crypto-js';

const secretKey = 'your-secret-key';

function encryptId(id) {
    return encodeURIComponent(CryptoJS.AES.encrypt(id.toString(), secretKey).toString());
}

export function redirectToExercise(activityList, navigate) {
    if (activityList.length === 0) {
        console.log("All exercises done");
        navigate("/home");
    } else {
        const encryptedId = encryptId(activityList[0][0]);
        
        switch (activityList[0][1]) {
            case 'alternative uditivo':
                navigate(`/find-the-correct-word-audio/${encryptedId}`);
                break;
            case 'alternative visivo':
                navigate(`/find-the-correct-word-no-audio/${encryptedId}`);
                break;
            case 'associazione parola immagine':
                navigate(`/word-image/${encryptedId}`);
                break;
            case 'associazione stimolo scritto':
                navigate(`/stimuli-association/${encryptedId}`);
                break;
            case 'lettura modulata':
            case 'lettura modulata morfo':
                navigate(`/fast-read/${encryptedId}`);
                break;
            case 'scrittura stimolo uditivo':
                navigate(`/stimuli-audio/${encryptedId}`);
                break;
            case 'coppie base derivato':
                navigate(`/base-derivative-wall/${encryptedId}`);
                break;
            case 'pattern':
                navigate(`/pattern-morph/${encryptedId}`);
                break;
            case 'word building':
                navigate(`/word-build/${encryptedId}`);
                break;
            case 'word sort':
            case 'word sort semantica':
                navigate(`/word-sort/${encryptedId}`);
                break;
            case 'scrittura derivate da testo':
                navigate(`/write-derivative-word/${encryptedId}`);
                break;
            case 'word cracking':
                navigate(`/word-cracking/${encryptedId}`);
                break;
            case 'video tutorial':
                navigate(`/tutorial/${encryptedId}`);
                break;
            default:
                console.warn('Unhandled activity type:', activityList[0][1]);
                break;
        }
    }
}

export async function getExerciseFromDB(activityList) {
    const axiosConfig = {
        withCredentials: true,
        headers: {
            'Content-Type': 'application/json'
        }
    };
    try {
        const response = await axios.post(
            `${process.env.REACT_APP_API_URL}/api/getExercise`,
            {exercise_id: activityList[0][0]},
            axiosConfig
        );
        if (response.data.success) {
            return response.data;
        } else {
            console.log(response.data.errorMess);
        }
    } catch (error) {
        console.log(error);
    }
}

export async function getLog(activityId) {
    const axiosConfig = {
        withCredentials: true,
        headers: {
            'Content-Type': 'application/json'
        }
    };
    try {
        const response = await axios.post(
            `${process.env.REACT_APP_API_URL}/api/getLog`,
            {activity_id: activityId},
            axiosConfig
        );
        if (response.data.success) {
            return response.data;
        } else {
            console.log(response.data.errorMess);
        }
    } catch (error) {
        console.log(error);
    }
}

export async function checkActivityStatus(currentActivity, activityList) {
    try {
        const response = await getLog(currentActivity);
        if (response.success) {
            const exercises = JSON.parse(JSON.stringify(response.data))[0];
            exercises.forEach((exercise) => {
                if(exercise.progress === 100) {
                    activityList.forEach((activity) => {
                        if(activity[0] === exercise.exercise_id) {
                            activityList.shift();
                        }
                    });
                }
            });
            return activityList;
        } else {
            console.log(response.errorMess);
        }
    } catch (error) {
        console.log(error);
    }
}

export async function updateCurrentLog(activityId, log) {
    try {
        const response = await getLog(activityId);
        
        if (response.success) {
            const exercisesString = JSON.stringify(response.data);
            const exercises = JSON.parse(exercisesString)[0];
            exercises.forEach((exercise) => {
                if (exercise.exercise_id === log.exercise_id) {
                    exercise.progress = log.progress;
                    exercise.actions = log.actions;
                }
            });
            await saveLogToDB(activityId, exercises);
        } else {
            console.error('Failed to save log:', response.errorMess);
        }
    } catch (error) {
        if (error.response) {
            console.error('Server error:', error.response.data);
        } else if (error.request) {
            console.error('No response from server. Network error or CORS issue:', error.request);
        } else {
            console.error('Error in request setup:', error.message);
        }
    }
}

export async function saveLogToDB(activityId, log) {
    const axiosConfig = {
        withCredentials: true,
        headers: {
            'Content-Type': 'application/json'
        }
    };
    
    try {
        
        const log_str = JSON.stringify(log);
        const response = await axios.post(
            `${process.env.REACT_APP_API_URL}/api/saveLog`,
            {log_str: log_str, activity_id: activityId},
            axiosConfig
        );
        
        if (response.data.success) {
            console.log('Log saved successfully');
        } else {
            console.error('Failed to save log:', response.data.errorMess);
        }
    } catch (error) {
        if (error.response) {
            console.error('Server error:', error.response.data);
        } else if (error.request) {
            console.error('No response from server. Network error or CORS issue:', error.request);
        } else {
            console.error('Error in request setup:', error.message);
        }
    }
}

export async function getAudio(audioUrl) {
    const axiosConfig = {
        withCredentials: true,
        headers: {
            'Content-Type': 'application/json'
        }
    }
    
    try {
        const response = await axios.post(
            `${process.env.REACT_APP_API_URL}/api/getAudio`,
            {audio_url: audioUrl},
            axiosConfig
        );
        if (response.data.success) {
            return response.data;
        } else {
            console.log(response.data.errorMess);
        }
    } catch (error) {
        console.log(error);
    }
}

export async function createAudioUrl(bubbles) {
    for (const bubble of bubbles) {
        if (bubble.correct) {
            return generateUrl(bubble.choiceText);
        }
    }
    return null;
}

export async function generateUrl(word) {
    try {
        const response = await getAudio(word);
        
        if (response.success) {
            const base64Audio = response.data;
            const binaryData = atob(base64Audio);
            const byteNumbers = new Uint8Array(binaryData.length);
            
            for (let i = 0; i < binaryData.length; i++) {
                byteNumbers[i] = binaryData.charCodeAt(i);
            }
            
            const blob = new Blob([byteNumbers], { type: 'audio/mpeg' });
            
            return URL.createObjectURL(blob);
        } else {
            console.error(response.errorMess);
            return null;
        }
    } catch (error) {
        console.error('Error fetching audio:', error);
        return null;
    }
}

export async function getImage(imageUrl) {
    const axiosConfig = {
        withCredentials: true,
        headers: {
            'Content-Type': 'application/json'
        }
    }
    
    try {
        const response = await axios.post(
            `${process.env.REACT_APP_API_URL}/api/getImage`,
            {image_url: imageUrl},
            axiosConfig
        );
        if (response.data.success) {
            return response.data;
        } else {
            console.log(response.data.errorMess);
        }
    } catch (error) {
        console.log(error);
    }
}

export async function createImageUrl(bubbles) {
    for (const bubble of bubbles) {
        if (bubble.correct) {
            try {
                const word = await replaceAccentedCharacters(bubble.choiceText);
                const response = await getImage(word);
                
                if (response.success) {
                    const base64Image = response.data;
                    const binaryData = atob(base64Image);
                    const byteNumbers = new Uint8Array(binaryData.length);
                    
                    for (let i = 0; i < binaryData.length; i++) {
                        byteNumbers[i] = binaryData.charCodeAt(i);
                    }
                    
                    const blob = new Blob([byteNumbers], { type: 'image/png' });
                    return URL.createObjectURL(blob);
                    
                } else {
                    console.error(response.errorMess);
                    return null;
                }
            } catch (error) {
                console.error('Error fetching image:', error.response?.data || error.message);
                return null;
            }
        }
    }
    return null;
}

export async function getVideo(videoUrl) {
    const axiosConfig = {
        withCredentials: true,
        headers: {
            'Content-Type': 'application/json'
        }
    }
    
    try {
        const response = await axios.post(
            `${process.env.REACT_APP_API_URL}/api/getVideo`,
            {video_url: videoUrl},
            axiosConfig
        );
        if (response.data.success) {
            return response.data;
        } else {
            console.log(response.data.errorMess);
        }
    } catch (error) {
        console.log(error);
    }
}

export async function replaceAccentedCharacters(word) {
    const accentMap = {
        'à': 'a', 'è': 'e', 'ì': 'i', 'ò': 'o', 'ù': 'u',
        'á': 'a', 'é': 'e', 'í': 'i', 'ó': 'o', 'ú': 'u',
        'â': 'a', 'ê': 'e', 'î': 'i', 'ô': 'o', 'û': 'u',
        'ä': 'a', 'ë': 'e', 'ï': 'i', 'ö': 'o', 'ü': 'u',
        'ã': 'a', 'ẽ': 'e', 'ĩ': 'i', 'õ': 'o', 'ũ': 'u',
        'å': 'a', 'ç': 'c', 'ñ': 'n'
    };
    
    return word.split('').map(char => accentMap[char] || char).join('');
}

export function randomizeWords(words) {
    for (let i = words.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [words[i], words[j]] = [words[j], words[i]];
    }
    
    return words
}

export function delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}




